import template from './sw-cms-el-preview-form.html.twig';
import './sw-cms-el-preview-form.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
